function findMenuById(menus, id) {
  if (!Array.isArray(menus)) {
    return null
  }

  for (const menu of menus) {
    if (menu.id === id || menu.menuId === id) {
      return menu
    }

    if (menu.items && Array.isArray(menu.items)) {
      const found = findMenuById(menu.items, id)
      if (found) {
        return found
      }
    }
  }

  return null
}

export function getMenuIcon(id) {
  if (!window.sideMenu?.menusData) {
    return null
  }

  const menu = findMenuById(window.sideMenu.menusData, id)
  return menu?.icon || null
}

export function createMenuIconMap() {
  const iconMap = new Map()

  if (!window.sideMenu?.menusData) {
    return iconMap
  }

  function traverse(menus, inheritedIcon = null) {
    if (!Array.isArray(menus)) return

    for (const menu of menus) {
      const menuId = menu.id || menu.menuId
      if (!menuId) continue

      const currentIcon = menu.icon || inheritedIcon

      if (currentIcon) {
        iconMap.set(menuId, currentIcon)
      }

      if (menu.items) {
        traverse(menu.items, currentIcon)
      }
    }
  }

  traverse(window.sideMenu.menusData)
  return iconMap
}
